import { render, staticRenderFns } from "./PaymentReceiptIsUsedField.vue?vue&type=template&id=482b6d3b"
import script from "./PaymentReceiptIsUsedField.vue?vue&type=script&lang=js"
export * from "./PaymentReceiptIsUsedField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports